import { Menu as BaseMenu } from '@base-ui/react/menu'
import { type VariantProps } from 'class-variance-authority'
import { twMerge } from 'tailwind-merge'
import { menuItemVariants } from './item'
import type { PartProps } from '../../../lib/part-props'

interface MenuLinkItemProps extends PartProps<BaseMenu.LinkItem.Props>, VariantProps<typeof menuItemVariants> {
  className?: string
}

function MenuLinkItem({ variant, className, children, closeOnClick = true, ...props }: MenuLinkItemProps) {
  return (
    <BaseMenu.LinkItem
      data-slot="list-item"
      className={twMerge(menuItemVariants({ variant }), 'no-underline', className)}
      closeOnClick={closeOnClick}
      {...props}
    >
      {children}
    </BaseMenu.LinkItem>
  )
}

export { MenuLinkItem }
